import React from 'react'
import Image, { StaticImageData } from 'next/legacy/image'
import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

import { ReactComponent as BlueArrow } from './arrow.svg'

interface QuestionCardProps {
  title: string
  text: string
  imgSrc: StaticImageData
  cardId: string
  resourceHref: string
  linkText: string
}

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 372px;
  height: auto;
  background: ${colors.white};

  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: ${colors.grey88};
  border-radius: 6px;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    width: 100%;
  }
`

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const CardTitle = styled.h3`
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.black};
  margin: 0;
`

const CardText = styled.p`
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.black};
  margin: 0 0 28px 0;
`

const DownloadWrapper = styled.div`
  display: flex;
  cursor: pointer;

  :hover {
    opacity: 0.7;
    transition: opacity 1s;
  }
`

const DownloadText = styled.a`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.link};
  margin: 0;
  text-decoration: none;
`

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;

  > svg {
    width: 12px;
    height: 12px;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 24px;
`

const QuestionCard: React.FC<QuestionCardProps> = ({
  cardId,
  title,
  text,
  imgSrc,
  linkText,
  resourceHref
}) => {
  return (
    <CardWrapper>
      <InnerWrapper>
        <Image
          src={imgSrc}
          alt=""
          placeholder="blur"
          sizes={`(max-width: ${breakpoints.tabletLandscape}) 488px, 325px`}
          style={{ borderRadius: '6px 6px 0 0' }}
        />
        <ContentWrapper>
          <CardTitle>{title}</CardTitle>
          <CardText>{text}</CardText>
          <DownloadText
            id={`landlord-${cardId}-readmore-text-click`}
            href={resourceHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadWrapper>
              {linkText}
              <ArrowWrapper>
                <BlueArrow />
              </ArrowWrapper>
            </DownloadWrapper>
          </DownloadText>
        </ContentWrapper>
      </InnerWrapper>
    </CardWrapper>
  )
}

export default QuestionCard
